import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';

import { UserService } from '@celum/authentication';
import { isTruthy } from '@celum/core';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  private router = inject(Router);
  private userService = inject(UserService);

  public canActivate(): Observable<boolean> {
    return this.userService.currentUser$.pipe(
      isTruthy(),
      map(currentUser => {
        const isAdmin = currentUser.admin;

        if (isAdmin) {
          return true;
        }

        this.router.navigateByUrl('/no-permission');
        return false;
      })
    );
  }
}
